const BRAND_TABS_CONSTANTS = {
  BRAND_TABS_NAVIGATION_XHR: 'BRAND_TABS_NAVIGATION_XHR',
};

const BRAND_TO_UPDATE_COOKIE = {
  gymboree: 'GYM',
  tcp: 'TCP',
  snj: 'SNJ',
  pjp: 'PJP',
};

export { BRAND_TABS_CONSTANTS, BRAND_TO_UPDATE_COOKIE };
